import styled from '@emotion/styled'
import { Colors } from '~/assets/style/colors'
import { Fonts } from '~/assets/style/fonts'

export const SpreadsheetContainer = styled.div<{ $fillHeight?: boolean }>`
  width: 100%;
  ${({ $fillHeight }) => ($fillHeight ? 'flex: 1; min-height: 0; display: flex; flex-direction: column;' : 'max-height: 450px;')}

  table {
    width: 100%;
    box-sizing: border-box;
    border-collapse: separate;
    border-spacing: 0;
    --header-background-color: #f6f6f6;

    tr {
      th:first-of-type,
      td:first-of-type {
        width: 5ch;
      }
    }

    // "position: sticky" used alongside "table { border-collapse: collapse; }" is causing visual bugs on borders when scrolling
          // => use "border-collapse: separate" and set borders manually to bypass this issue. Ugly code but allows to get rid of visual bug on borders..
          tr:first-of-type {
      th {
        position: sticky;
        top: 0;
        z-index: 1;

        ::after {
          content: '';
          position: absolute;
          left: 0;
          right: 0;
          bottom: 0;
          height: 1px;
          background-color: var(--border-color);
        }
      }
    }

    tr:nth-of-type(2) {
      th,
      td {
        border-top: none;
      }
    }

    th:not(:last-child),
    td:not(:last-child) {
      border-right: none;
    }

    tr:not(:last-child) {
      th,
      td {
        border-bottom: none;
      }
    }
  }
`

export const NoDataSpreadsheet = styled.div<{ $fillHeight?: boolean }>`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 20px;
  ${Fonts.P0}
  ${({ $fillHeight }) => ($fillHeight ? 'flex: 1; min-height: 0;' : 'height: 440px;')}
`

export const Header = styled.th<{ fixedWidth?: number }>`
  line-height: 1.25rem;
  font-size: 0.875rem;
  ${({ fixedWidth }) => fixedWidth && `width: ${fixedWidth}px;`}
`

export const CellContainer = styled.td<{ hasError?: boolean; readonly?: boolean }>`
  > div {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 4px;
    padding: 0 4px;
    width: 100%;
    height: 100%;
    line-height: 1.25rem;
    font-size: 0.875rem;
    
  }
  ${({ hasError }) => hasError && `background-color: ${Colors.Mew};`};
  --readonly-text-color: ${Colors.Ash};
  ${({ readonly }) => readonly && `background-color: rgba(0, 0, 0, 0.04);`};
`
export const RowIndicator = styled.th<{ hasError?: boolean; selected: boolean }>`
  line-height: 1.25rem;
  font-size: 0.875rem;
  background-color: ${({ selected, hasError }) => hasError && (selected ? Colors.Ash : Colors.Mew)};
  color: ${({ selected, hasError }) => hasError && (selected ? Colors.Mew : Colors.Alert)};
`
